<template>
  <TemplateBase>
    <main class="relative z-0 col-span-full row-start-2">
      <!-- Breadcrumbs -->
      <OrganismNavigationBreadcrumb :path="breadcrumbs" class="container mb-4 mx-auto pt-10 px-4 md:mb-8" />

      <!-- Section with container and grid for page content -->
      <section
        class="margin-bottom-page-content-without-content-items-following container relative grid grid-cols-12 mx-auto px-4"
        :class="{
          'page-image-container': page.images.length,
        }"
      >
        <!-- Div with responsive page layout in columns -->
        <div
          v-if="page.images.length || page.description"
          class="relative z-40 col-span-full 2xl:col-end-10 2xl:col-start-4 lg:col-end-12 lg:col-start-2 xl:col-end-11 xl:col-start-3"
        >
          <!-- White sheet with page content -->
          <div class="padding-page-content relative flex flex-col bg-white rounded-b-none rounded-t-xl">
            <time class="block mb-1 text-black whitespace-nowrap text-sm leading-none uppercase md:mb-3 md:text-lg">
              {{ $d(new Date(page.dateCreated), 'medium-date') }}
            </time>

            <!-- Page header -->
            <h1 class="mb-1 text-2xl text-black font-black leading-tight uppercase md:mb-4 md:text-3xl md:font-bold md:leading-none lg:text-4xl xl:text-5xl">
              {{ page.title }}
            </h1>

            <section v-if="page.images.length" class="relative order-1 rounded-xl overflow-hidden md:order-2 lg:-mx-32">
              <MoleculeImageCarousel :images="page.images" :add-shadow="false" />
            </section>

            <div v-if="page.message" class="prose prose--app order-2 mb-6 pb-2 max-w-none border-b border-solid border-app-green overflow-auto" v-html="page.message" />

            <div v-if="page.department" class="text-black order-3">
              <h3 class="text-xl font-bold uppercase">{{ page.department.title }}</h3>
              <section>
                {{ page.department.address.streetName }}
                {{ page.department.address.streetNumber }}
              </section>
              <section class="mb-2">
                {{ page.department.address.postalCode }}
                {{ page.department.address.city }}
              </section>

              <AtomLink v-if="page.department.webPage" :url="page.department.webPage" class="text-black block mb-2">
                <span class="underline transition hover:text-app-green">Naar onze website</span>
              </AtomLink>

              <div v-if="page.department.visitingHours" class="mt-4" v-html="page.department.visitingHours" />
            </div>
          </div>
        </div>
      </section>
    </main>
  </TemplateBase>
</template>

<script setup lang="ts">
interface Props {
  breadcrumbs: Array<any>
  page: {
    images: Array<any>
    description?: string
    dateCreated: string
    title: string
    message?: string
    department?: {
      title: string
      address: {
        streetName: string
        streetNumber: string
        postalCode: string
        city: string
      }
      webPage?: string
      visitingHours?: string
    }
  }
}

withDefaults(defineProps<Props>(), {})
</script>
